module.exports = __webpack_public_path__ + "static/media/life-redemption-banner-graphic.b0aa85de.png";